import { Container } from "@mui/material";
import { useRouteMatch } from "react-router-dom";
import { makeStyles } from "components/providers/makeStyles";
import { newManageEventPagesPath } from "components/application";
import { EventDivisionHeader } from "components/layout/eventDivision/EventDivisionHeader";
import { EventDivisionDirectorHeader } from "components/routes/events/id/divisions/eventDivisionId/header/EventDivisionDirectorHeader";

const useStyles = makeStyles((theme, { newEventManagementPathMatch }) => ({
    container: {
        paddingBottom: theme.spacing(5),
        maxWidth: newEventManagementPathMatch && "100vw", // this makes a difference only when sidebar is collapsed
        "&&": {
            paddingLeft: newEventManagementPathMatch && theme.spacing(2), // align padding with other director pages
            paddingRight: newEventManagementPathMatch && theme.spacing(2), // align padding with other director pages
        },
        "@media print": {
            padding: 0
        }
    },
    header: {
        "&&": {
            paddingLeft: 0,
            paddingRight: 0,
            [theme.breakpoints.down("md")]: {
                width: newEventManagementPathMatch && "auto"
            }
        }
    }
}));

export const EventDivisionContainer = ({ children }) => {
    const newEventManagementPathMatch = useRouteMatch(newManageEventPagesPath);
    const classes = useStyles({ newEventManagementPathMatch });

    return (
        <Container maxWidth={newEventManagementPathMatch ? false : "lg"} className={classes.container}>
            {newEventManagementPathMatch ? <EventDivisionDirectorHeader className={classes.header}/> : <EventDivisionHeader/>}
            {children}
        </Container>
    );
};
